import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentUser } from 'src/app/data/store/selectors/users.selectors';
import { UserDataImgSize } from 'src/app/shared/enums';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { AsyncPipe } from '@angular/common';
import { UserDataComponent } from '../../../../../shared/components/user-data/user-data.component';
import { ImageComponent } from '../../../../../shared/components/image/image.component';
import { GetFullNamePipe } from '../../../../../shared/pipe/get-full-name/get-full-name.pipe';

@Component({
  selector: 'app-mobile-menu-user',
  templateUrl: './mobile-menu-user.component.html',
  styleUrls: ['./mobile-menu-user.component.scss'],
  imports: [UserDataComponent, ImageComponent, AsyncPipe, GetFullNamePipe],
})
export class MobileMenuUserComponent {
  private _store = inject(Store);
  utils = inject(UtilsService);

  public currentUser$ = this._store.select(selectCurrentUser);

  readonly UserDataImgSize = UserDataImgSize;
}
